import React from 'react';
import { connect } from "react-redux";
import PropTypes from "prop-types";

import SvgIcon from "@mui/material/SvgIcon";

import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS, PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../analytics";
import {LOOK_OVERLAYS} from "../../core/constants";
import {IS_PRODUCT_JOURNEY} from "../../../../config";

import {setLookOverlayOpened} from "../../../../actions/lookFunctions";
import {GroheLockIcon} from "../../../common/icons";

const LookLockedButton = (props) => {

  const {setLookOverlayOpened, className} = props;

  const lockedButtonClick = () => {
    const analyticsLabel = IS_PRODUCT_JOURNEY
      ? PRODUCT_JOURNEY_ANALYTIC_EVENTS.productLockedButton
      : LOOK_JOURNEY_ANALYTIC_EVENTS.lookLockedButton;
    Analytics.sendClickEvent(analyticsLabel);

    setLookOverlayOpened(LOOK_OVERLAYS.leadCapture);
  }

  return (
    <div className={className || "lk-button__lock"} onClick={lockedButtonClick}>
      <SvgIcon fontSize={"inherit"}>
        <GroheLockIcon/>
      </SvgIcon>
    </div>
  )
};

LookLockedButton.propTypes = {
  className: PropTypes.string,
}

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = {
  setLookOverlayOpened
};

export default connect(mapStateToProps, mapDispatchToProps)(LookLockedButton)
